import { gql, useSuspenseQuery } from '@apollo/client';

import { VisitPatientAlertDefaultQuery } from './useVisitPatientAlertDefault.gql.types';

export const OrgPatientAlertConfigFragment = gql`
    fragment OrgPatientAlertConfig on Organization {
        id
        config {
            id
            communications {
                id
                shouldSendPatientAlertsUiToggleDefault
            }
        }
    }
`;
export const VISIT_PATIENT_ALERT_DEFAULT_QUERY = gql`
    query VisitPatientAlertDefault($id: UUID!) {
        visit(id: $id) {
            organization {
                config {
                    communications {
                        shouldSendPatientAlertsUiToggleDefault
                    }
                }
            }
        }
    }
`;

export const useVisitPatientAlertDefault = (visitId: string): boolean => {
    const { data } = useSuspenseQuery<VisitPatientAlertDefaultQuery>(
        VISIT_PATIENT_ALERT_DEFAULT_QUERY,
        { variables: { id: visitId } },
    );
    return (
        data.visit?.organization.config.communications.shouldSendPatientAlertsUiToggleDefault ??
        true
    );
};
